import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../components/home/HomePage'
import ShortIntroduce from '../components/introduce/ShortIntroduce'
import CompanyCulture from '../components/introduce/CompanyCulture'
import HonorPage from '../components/introduce/HonorPage'
import CoreTeam from '../components/introduce/CoreTeam'
import Software from '../components/product/Software'
import Hardware from '../components/product/Hardware'
import SoluPage from '../components/solution/SoluPage'
import NewsPage from '../components/news/NewsPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/short_introduce',
      name: 'ShortIntroduce',
      component: ShortIntroduce
    },
    {
      path: '/culture',
      name: 'CompanyCulture',
      component: CompanyCulture
    },
    {
      path: '/honor',
      name: 'HonorPage',
      component: HonorPage
    },
    {
      path: '/team',
      name: 'CoreTeam',
      component: CoreTeam
    },
    {
      path: '/software',
      name: 'Software',
      component: Software
    },
    {
      path: '/hardware',
      name: 'Hardware',
      component: Hardware
    },
    {
      path: '/solution',
      name: 'SoluPage',
      component: SoluPage
    },
    {
      path: '/news',
      name: 'NewsPage',
      component: NewsPage
    }
  ]
})

export function routerTo (router, name, data) {
  router.push({
    name: name,
    query: data
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js